export default __webpack_public_path__ + "static/media/EmptyWalletLogo.47f671ee.svg";